import axios from 'axios';
import { auth } from '../firebase';

// Attach the signed-in employer's Firebase ID token to every call to our Netlify functions,
// so the server can verify who is calling (SEC-001). If a token can't be fetched, the
// request goes out unchanged and the server answers 401.
//
// The server also requires a verified email (SEC-001.4). Firebase caches the ID token for up
// to an hour, so right after an employer verifies their email the cached token still says
// email_verified=false. When the account is verified but the token isn't, force a refresh.
axios.interceptors.request.use(async (config) => {
  try {
    const url = config.url || '';
    if (url.startsWith('/.netlify/functions/') && auth.currentUser) {
      const user = auth.currentUser;
      let token = await user.getIdToken();
      if (user.emailVerified) {
        const { claims } = await user.getIdTokenResult();
        if (!claims.email_verified) token = await user.getIdToken(true);
      }
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
  } catch (err) {
    console.log(err);
  }
  return config;
});
